var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-dialog', {
    staticClass: "userSetting",
    attrs: {
      "title": _vm.$t('startNewParty.participantSetting'),
      "visible": _vm.info.show,
      "show-close": _vm.info.userInfo && _vm.info.userInfo.nickName ? true : false,
      "top": "10px",
      "close-on-click-modal": false,
      "append-to-body": true,
      "width": "450px"
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.info, "show", $event);
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "nickname",
    class: {
      red: _vm.redTips
    }
  }, [_c('span', [_c('label', [_vm._v("*")]), _vm._v(_vm._s(_vm.$t('startNewParty.name')) + ":")]), _c('el-input', {
    attrs: {
      "maxlength": 32
    },
    on: {
      "blur": function ($event) {
        return _vm.blurFn('nickName');
      }
    },
    model: {
      value: _vm.nickName,
      callback: function ($$v) {
        _vm.nickName = $$v;
      },
      expression: "nickName"
    }
  }), _vm.redTips ? _c('p', [_vm._v(_vm._s(_vm.redTips))]) : _vm._e()], 1), _vm.$route.name == 'reporterParticipate' || _vm.$route.name == 'coordinator' || _vm.$route.name === 'newCoordinator' ? _c('div', {
    staticClass: "nickname",
    class: {
      red: _vm.redTips1
    },
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('startNewParty.corporation')) + ":")]), _c('el-input', {
    attrs: {
      "maxlength": 256
    },
    model: {
      value: _vm.organization,
      callback: function ($$v) {
        _vm.organization = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "organization"
    }
  }), _vm.redTips1 ? _c('p', [_vm._v(_vm._s(_vm.redTips1))]) : _vm._e()], 1) : _vm._e(), !_vm.info.hideBtn ? _c('div', [_c('span', {
    staticClass: "aduio"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('commonFunction.soundOfSite'),
      "placement": "bottom"
    }
  }, [!_vm.setInfo.mute ? _c('svg', {
    staticClass: "muteVolume",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-a-TypespeakerStateonWhiteoff"
    }
  })]) : _c('svg', {
    staticClass: "muteVolume",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-a-TypespeakerStateoffWhiteoff"
    }
  })])]), _c('span', {
    staticClass: "btn"
  }, [_c('i', {
    class: {
      gray: _vm.setInfo.mute
    },
    on: {
      "click": function ($event) {
        return _vm.setBtn('mute', false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.on')) + " ")]), _vm._v("/ "), _c('i', {
    class: {
      gray: !_vm.setInfo.mute
    },
    on: {
      "click": function ($event) {
        return _vm.setBtn('mute', true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.off')))])])], 1), _c('span', {
    staticClass: "aduio"
  }, [_vm.State.hasVideo ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('operationBtn.camera'),
      "placement": "bottom"
    }
  }, [!_vm.setInfo.noCamera ? _c('svg', {
    staticClass: "muteVolume",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-a-cameraStateonwhiteoff"
    }
  })]) : _c('svg', {
    staticClass: "muteVolume",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-a-cameraStateoffwhiteoff"
    }
  })])]) : _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('commonFunction.noAccess'),
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_c('svg', {
    staticClass: "iconfont carmerHover",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-camerahover"
    }
  })])])]), _c('span', {
    staticClass: "btn"
  }, [_c('i', {
    class: {
      gray: _vm.setInfo.noCamera || !_vm.State.hasVideo,
      notAllowed: !_vm.State.hasVideo
    },
    on: {
      "click": function ($event) {
        return _vm.setBtn('noCamera', false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.on')) + " ")]), _vm._v("/ "), _c('i', {
    class: {
      gray: !_vm.setInfo.noCamera && _vm.State.hasVideo,
      notAllowed: !_vm.State.hasVideo
    },
    on: {
      "click": function ($event) {
        return _vm.setBtn('noCamera', true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.off')))])])], 1), _c('span', {
    staticClass: "aduio"
  }, [_vm.State.hasAudio ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('commonFunction.audio'),
      "placement": "bottom"
    }
  }, [!_vm.setInfo.noAudio ? _c('svg', {
    staticClass: "muteVolume",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-a-micStateonwhiteoff"
    }
  })]) : _c('svg', {
    staticClass: "muteVolume",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-a-micStateoffwhiteoff"
    }
  })])]) : _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('commonFunction.noAccess'),
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_c('svg', {
    staticClass: "iconfont audio carmerHover",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-Michover"
    }
  })])])]), _c('span', {
    staticClass: "btn"
  }, [_c('i', {
    class: {
      gray: _vm.setInfo.noAudio || !_vm.State.hasAudio,
      notAllowed: !_vm.State.hasAudio
    },
    on: {
      "click": function ($event) {
        return _vm.setBtn('noAudio', false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.on')) + " ")]), _vm._v("/ "), _c('i', {
    class: {
      gray: !_vm.setInfo.noAudio && _vm.State.hasAudio,
      notAllowed: !_vm.State.hasAudio
    },
    on: {
      "click": function ($event) {
        return _vm.setBtn('noAudio', true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.off')))])])], 1)]) : _vm._e()]), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm.info.userInfo && _vm.info.userInfo.nickName ? _c('el-button', {
    staticClass: "gray",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.cancel')))]) : _vm._e(), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.submit')))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };